import type { ReactElement } from 'react';

import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';
import { translate } from '@web-platform/shared-universal-translations';
import { GLOBAL } from 'saddlebag-browser';

import STYLES from './SeoHeader.module.scss';

const SeoHeader = (): ReactElement => {
  const { h1 } = GLOBAL.getWindow().__internal;

  return (
    <BpkText
      tagName="h1"
      textStyle={TEXT_STYLES.caption}
      aria-hidden="true"
      className={STYLES.seoHeader}
      color={TEXT_COLORS.textOnDark}
    >
      {/* We get H1 heading from Contentful (via content-api, also known as Landing Pages API) to add it to the top of DOM for SEO (bots), and then to visually move this down to Footer using CSS */}
      {h1 || translate('label_footer_tagline')}
    </BpkText>
  );
};

export default SeoHeader;
